import { SHELF_RANGES } from "flows/Inventory/shared/hooks/useFilteredChecks";

type FilterableRestockingItem = {
  product: {
    shelfNumber: string | null;
    productClassification?: string[] | null;
  } | null;
  priorityTier?: string | null;
};

export function applyRestockingFilters<T extends FilterableRestockingItem>(
  items: T[],
  categoryFilters: string[],
  shelfFilters: string[],
  priorityFilters: string[] = [],
): T[] {
  let result = items;

  if (categoryFilters.length > 0) {
    result = result.filter(
      (item) =>
        item.product?.productClassification?.some((c) => categoryFilters.includes(c)) ?? false,
    );
  }

  if (shelfFilters.length > 0) {
    result = result.filter((item) => {
      const shelfNumber = Number(item.product?.shelfNumber);
      return shelfFilters.some((range) => {
        switch (range) {
          case SHELF_RANGES.RANGE_001_028:
            return shelfNumber >= 1 && shelfNumber <= 28;
          case SHELF_RANGES.RANGE_029_056:
            return shelfNumber >= 29 && shelfNumber <= 56;
          case SHELF_RANGES.RANGE_057_084:
            return shelfNumber >= 57 && shelfNumber <= 84;
          case SHELF_RANGES.RANGE_085_112:
            return shelfNumber >= 85 && shelfNumber <= 112;
          case SHELF_RANGES.RANGE_OVER_112:
            return shelfNumber > 112;
          default:
            return true;
        }
      });
    });
  }

  if (priorityFilters.length > 0) {
    result = result.filter(
      (item) => item.priorityTier != null && priorityFilters.includes(item.priorityTier),
    );
  }

  return result;
}
